import { debounce } from 'lodash';
import { api } from '@/utils';

export default {
  name: 'ClientInfo',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    selectedClient: null,
    selectedVessel: null,
    selectedTerminal: null,
    selectedBerth: null,
    formFields: {
      client: {
        name: 'client',
        label: 'Client',
        validation: 'required',
      },
      vessel: {
        name: 'vessel',
        label: 'Vessel',
        validation: 'required',
      },
      terminal: {
        name: 'terminal',
        label: 'Terminal',
        validation: 'required',
      },
      berth: {
        name: 'berth',
        label: 'Berth',
        validation: 'required',
      },
    },
    // search props
    apiVersion: 1,
    pageSize: 10,
    searchClient: null,
    isLoadingClient: false,
    stakeholderEntries: [],
    searchVessel: null,
    isLoadingVessel: false,
    vesselEntries: [],
    allTerminals: [],
    searchTerminal: null,
    isLoadingTerminal: false,
    terminalEntries: [],
    berths: [],
  }),
  computed: {
    vesselItems() {
      return this.vesselEntries.map((entry) => {
        let autocompleteValue = `${entry.name}`;
        if (entry.imo !== null || entry.imo !== 0) {
          autocompleteValue = `${entry.name} - ${entry.imo}`;
        }
        return Object.assign({}, entry, { autocompleteValue });
      });
    },
    terminalItems() {
      return this.terminalEntries.map((entry) => {
        const autocompleteValue = `${entry.name}`;
        return Object.assign({}, entry, { autocompleteValue });
      });
    },
  },
  methods: {
    setClient(id) {
      // BASEURL
      const url = `/stakeholders/${id}`;

      api
        .get(url)
        .then((response) => {
          this.selectedClient = response.data;
          this.stakeholderEntries.push(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setVessel(id) {
      // BASEURL
      const url = `/vessels/${id}`;

      api
        .get(url)
        .then((response) => {
          // eslint-disable-next-line
          response.data.autocompleteValue = response.data.name;
          this.selectedVessel = response.data;
          this.vesselEntries.push(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setTerminalAndBerth(code, berthCode) {
      const terminal = this.allTerminals.find(t => t.code === code);
      terminal.autocompleteValue = terminal.code;
      this.selectedTerminal = terminal;
      this.terminalEntries.push(terminal);

      setTimeout(() => {
        this.selectedBerth = berthCode;
        this.berths.push(berthCode);
      }, 250);
    },
    searchStakeholder: debounce(function fetchStakeHolders() {
      this.isLoadingClient = true;

      // BASEURL
      let url = '/stakeholders?';

      // Name
      url += `name=${this.searchClient}`;

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      api
        .get(url)
        .then((response) => {
          this.stakeholderEntries = response.data;
          this.isLoadingClient = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 300),
    searchVessels: debounce(function fetchVessels() {
      this.isLoadingVessel = true;

      // BASEURL
      let url = '/vessels?';

      // Name
      url += `name=${this.searchVessel}`;

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      api
        .get(url)
        .then((response) => {
          this.vesselEntries = response.data;
          this.isLoadingVessel = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 300),
    searchTerminals: debounce(function fetchTerminals() {
      this.isLoadingTerminal = true;
      this.terminalEntries = this.allTerminals.filter(this.searchTerminalByName).slice(0, 10);
      this.isLoadingTerminal = false;
    }, 300),
    searchTerminalByName(terminal) {
      const searchValue = this.searchTerminal != null ? this.searchTerminal.toLowerCase() : '';
      return terminal.name.toLowerCase().includes(searchValue);
    },
    getTerminals() {
      // BASEURL
      const url = '/ports/BEANR';

      api
        .get(url)
        .then((response) => {
          this.allTerminals = response.data.terminals;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadBerths() {
      if (this.selectedTerminal != null) {
        this.berths = this.selectedTerminal.berths.map(a => a.code);
      }
    },
    onInputFormSaved() {
      this.$validator
        .validateAll()
        .then((isValid) => {
          if (isValid) {
            const clientInfo = {
              selectedClient: this.selectedClient,
              selectedVessel: this.selectedVessel,
              selectedTerminal: this.selectedTerminal,
              selectedBerth: this.selectedBerth,
            };

            this.$eventHub.$emit('fetch-client-info', clientInfo);
          } else {
            this.$eventHub.$emit('fetch-client-info', null);
          }
        })
        .catch(() => {
          console.log('something went wrong in file ClientInfo.controller.js method onInputFormSaved');
        });
    },
    prefillClientInfo(dossier) {
      this.setClient(dossier.clientStakeholderId);
      this.setVessel(dossier.vessel.id);
      this.setTerminalAndBerth(dossier.terminal, dossier.berth);
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm != null) {
        if (this.inputForm.clientStakeholder != null) {
          this.setClient(this.inputForm.clientStakeholder.id);
        }

        const vessel = this.inputForm.vesselIdentification;
        if (vessel != null) {
          this.setVessel(vessel.vesselId);
        }

        const location = this.inputForm.locationIdentification;
        if (location != null) {
          // ToDo: Check als dit beter kan, terminals moeten eerst geladen worden
          setTimeout(() => {
            this.setTerminalAndBerth(location.terminalCode, location.berthCode);
          }, 750);
        }
      }
    },
    searchClient() {
      this.searchStakeholder();
    },
    searchVessel() {
      this.searchVessels();
    },
    searchTerminal() {
      this.selectedBerth = null;
      this.searchTerminals();
    },
    selectedTerminal() {
      this.selectedBerth = null;
      this.loadBerths();
    },
  },
  created() {
    this.getTerminals();
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
    if (this.$route.query.client != null) {
      this.setClient(this.$route.query.client);
    }
    this.$eventHub.$on('prefill-clientinfo', this.prefillClientInfo);
  },
};
